export const FETCH_FILES_FROM_BUCKET_REQUEST = 'FETCH_FILES_FROM_BUCKET_REQUEST';
export const FETCH_FILES_FROM_BUCKET_SUCCESS = 'FETCH_FILES_FROM_BUCKET_SUCCESS';
export const FETCH_FILES_FROM_BUCKET_FAILED = 'FETCH_FILES_FROM_BUCKET_FAILED';

export const POST_CREATE_FOLDER_REQUEST = 'POST_CREATE_FOLDER_REQUEST';
export const POST_CREATE_FOLDER_SUCCESS = 'POST_CREATE_FOLDER_SUCCESS';
export const POST_CREATE_FOLDER_FAILED = 'POST_CREATE_FOLDER_FAILED';

export const POST_ADD_FILE_REQUEST = 'POST_ADD_FILE_REQUEST';
export const POST_ADD_FILE_SUCCESS = 'POST_ADD_FILE_SUCCESS';
export const POST_ADD_FILE_FAILED = 'POST_ADD_FILE_FAILED';

export const DELETE_FILES_REQUEST = 'DELETE_FILES_REQUEST';
export const DELETE_FILES_SUCCESS = 'DELETE_FILES_SUCCESS';
export const DELETE_FILES_FAILED = 'DELETE_FILES_FAILED';

export const POST_EXPORT_FILES_REQUEST = 'POST_EXPORT_FILES_REQUEST';
export const POST_EXPORT_FILES_SUCCESS = 'POST_EXPORT_FILES_SUCCESS';
export const POST_EXPORT_FILES_FAILED = 'POST_EXPORT_FILES_FAILED';

export const SET_SELECTED_FILE = 'SET_SELECTED_FILE';
export const SELECT_ALL_FILES = 'SELECT_ALL_FILES';
export const ADD_FILES_TO_UPLOAD_LIST = 'ADD_FILES_TO_UPLOAD_LIST';
export const CHANGE_FILE_TO_UPLOAD = 'CHANGE_FILE_TO_UPLOAD';
export const RESET_FILES_TO_UPLOAD = 'RESET_FILES_TO_UPLOAD';
export const SET_HIERARCHY = 'SET_HIERARCHY';
export const RESET_UPLOAD_AND_SCAN = 'RESET_UPLOAD_AND_SCAN';
export const RESET_EXPORT_FILES = 'RESET_EXPORT_FILES';
